import React from 'react';

export const PenIcon: React.FC<{ color?: string }> = ({
  color = '#E4E4E4'
}) => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1740_3795)">
        <mask
          id="mask0_1740_3795"
          //   style="mask-type:alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="19"
          height="18"
        >
          <rect x="0.5" width="18" height="18" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_1740_3795)">
          <path
            d="M14.975 6.69375L11.7875 3.54375L12.8375 2.49375C13.125 2.20625 13.4781 2.0625 13.8969 2.0625C14.3156 2.0625 14.6687 2.20625 14.9562 2.49375L16.0063 3.54375C16.2938 3.83125 16.4437 4.17812 16.4562 4.58437C16.4688 4.99062 16.3313 5.3375 16.0438 5.625L14.975 6.69375ZM13.8875 7.8L5.9375 15.75H2.75V12.5625L10.7 4.6125L13.8875 7.8Z"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1740_3795">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
